import { SEO } from "@/components/SEO";
import { SpeakingHero }         from "../components/site/speaking/SpeakingHero";
import { TheShift }              from "../components/site/speaking/TheShift";
import { WhyNow }                from "../components/site/speaking/WhyNow";
import { Keynotes }              from "../components/site/speaking/Keynotes";
import { AudienceFormats }       from "../components/site/speaking/AudienceFormats";
import { SpeakingTestimonials }  from "../components/site/speaking/SpeakingTestimonials";
import { SpeakingCTA }           from "../components/site/speaking/SpeakingCTA";

export default function Speaking() {
  return (
    <div data-testid="speaking-page">
      <SEO
        title="Speaking"
        description="Book Lara Parrish to speak at your next event — keynotes and workshops on curiosity, joy, and building a life that feels like yours."
        path="/speaking"
      />
      <SpeakingHero />
      <TheShift />
      <WhyNow />
      <Keynotes />
      <AudienceFormats />
      <SpeakingTestimonials />
      <SpeakingCTA />
    </div>
  );
}
